import { Box, Center, Heading, Text } from "@chakra-ui/react";
export function ServiceBoard() {
  return (
    <Box margin="30px auto 100px" maxWidth="1100px">
      <Center mt="10" className="service-body">
        <Heading className="service-title">Terms</Heading>
        <Box className="service-box">
          <Text className="service-box-title">Article 1 (Purpose)</Text>
          <Text className="service-box-content">
            These terms and conditions are intended to define the rights,
            obligations, and responsibilities of the cyber site and its users
            when using the internet-related services (hereinafter referred to as
            "Services") provided by Partsgo (an e-commerce operator) on the
            Partsgo website (hereinafter referred to as "Site").
          </Text>
          <Text className="service-box-content">
            ※ These terms and conditions also apply to electronic transactions
            using PC communications, wireless networks, etc., as long as they do
            not conflict with their nature.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">Article 2 (Definitions)</Text>
          <Text className="service-box-content">
            ① "Site" refers to the virtual business place set up by Partsgo to
            enable transactions of goods or services (hereinafter referred to as
            "Goods, etc.") with users through information and communication
            equipment such as computers. It also refers to the operator of the
            cyber site.
          </Text>
          <Text className="service-box-content">
            ② "User" refers to both members and non-members who access the
            "Site" and use the services provided by the "Site" in accordance
            with these terms and conditions.
          </Text>
          <Text className="service-box-content">
            ③ "Member" refers to a person who has registered as a member on the
            "Site" and is able to continuously use the services provided by the
            "Site."
          </Text>
          <Text className="service-box-content">
            ④ "Non-member" refers to a person who uses the services provided by
            the "Site" without registering as a member.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 3 (Display, Explanation, and Amendment of Terms and
            Conditions)
          </Text>
          <Text className="service-box-content">
            ① The "Site" displays the contents of these terms and conditions,
            including the name of the business, representative's name, business
            address (including the address for handling consumer complaints),
            telephone number, fax number, email address, business registration
            number, e-commerce registration number, and the personal information
            manager, on the initial service screen of the Site so that users can
            easily access them. However, the terms and conditions can be made
            available via a linked screen if necessary.
          </Text>
          <Text className="service-box-content">
            ② Before users agree to the terms and conditions, the "Site" must
            provide a separate link or pop-up screen for users to understand
            important details, such as withdrawal of offers, responsibility for
            delivery, and refund conditions.
          </Text>
          <Text className="service-box-content">
            ③ The "Site" may amend these terms and conditions to the extent that
            it does not violate the laws related to consumer protection in
            electronic commerce, the regulation of terms and conditions, the
            Basic Act on Electronic Documents and Electronic Transactions, the
            Electronic Financial Transactions Act, the Electronic Signatures
            Act, the Act on Promotion of Information and Communications Network
            Utilization and Information Protection, the Act on Door-to-Door
            Sales, and the Basic Consumer Act.
          </Text>
          <Text className="service-box-content">
            ④ When the "Site" revises the terms and conditions, it will specify
            the effective date and reason for the amendment and notify users by
            posting the current and amended terms on the initial screen of the
            Site from at least 7 days before the effective date until the day
            before. However, if the changes are disadvantageous to users, the
            "Site" will provide at least a 30-day prior notice period. In this
            case, the "Site" will clearly compare the previous and revised terms
            for users to easily understand.
          </Text>
          <Text className="service-box-content">
            ⑤ If the "Site" revises the terms and conditions, the revised terms
            will only apply to contracts concluded after the effective date.
            Contracts concluded before that will continue to be governed by the
            previous terms, unless a user sends a request to the "Site" to apply
            the revised terms during the notice period mentioned in Paragraph 3
            and the "Site" agrees.
          </Text>
          <Text className="service-box-content">
            ⑥ Matters not specified in these terms and conditions and the
            interpretation of these terms will be governed by the laws related
            to consumer protection in electronic commerce, the regulation of
            terms and conditions, guidelines on consumer protection in
            electronic commerce set by the Fair Trade Commission, and relevant
            laws or customary practices.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 4 (Provision and Modification of Services)
          </Text>
          <Text className="service-box-content">
            ① The "Site" performs the following tasks:
          </Text>
          <Text className="service-box-content">
            1. Providing information on goods or services and facilitating
            purchase contracts
          </Text>
          <Text className="service-box-content">
            2. Delivering goods or services for which a purchase contract has
            been concluded
          </Text>
          <Text className="service-box-content">
            3. Other tasks determined by the "Site"
          </Text>
          <Text className="service-box-content">
            ② The "Site" may modify the content of goods or services provided
            under a future contract in the event of a shortage or technical
            specification changes. In such cases, the "Site" will immediately
            post the modified content and the date of provision at the location
            where the current goods or services are displayed.
          </Text>
          <Text className="service-box-content">
            ③ If the "Site" changes the content of the services agreed upon due
            to the shortage of goods or changes in technical specifications, the
            "Site" will immediately notify the user at an address where the user
            can be reached.
          </Text>
          <Text className="service-box-content">
            ④ In such cases, the "Site" will compensate users for any damages
            caused. However, the "Site" will not be liable if it can prove that
            there was no intention or negligence.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 5 (Service Interruption)
          </Text>
          <Text className="service-box-content">
            ① The "Site" may temporarily suspend the provision of services in
            the event of maintenance, replacement, malfunction of computer or
            communication equipment, or communication disruptions.
          </Text>
          <Text className="service-box-content">
            ② The "Site" will compensate users or third parties for damages
            caused by the temporary suspension of services as described in
            Paragraph 1. However, the "Site" will not be liable if it can prove
            that there was no intention or negligence.
          </Text>
          <Text className="service-box-content">
            ③ If the "Site" is unable to provide services due to changes in
            business categories, cessation of business, or mergers between
            companies, the "Site" will notify users in accordance with Article 8
            and compensate consumers according to the conditions originally
            presented by the "Site." However, if the "Site" has not informed
            users of compensation standards, users will be able to use mileage
            or points within a designated period set by the "Site."
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 6 (Membership Registration)
          </Text>
          <Text className="service-box-content">
            ① Users apply for membership by filling out the member information
            according to the registration form provided by the "Site" and
            indicating their agreement to these terms and conditions.
          </Text>
          <Text className="service-box-content">
            ② The "Site" will register users who have applied for membership as
            described in Paragraph 1, unless they fall under any of the
            following:
          </Text>
          <Text className="service-box-content">
            1. If the applicant has previously lost their membership status
            under Article 7(3) of these terms and conditions. However,
            exceptions are made if the applicant has been reinstated as a member
            by the "Site" after three years from the loss of membership under
            Article 7(3).
          </Text>
          <Text className="service-box-content">
            2. If there are false, missing, or incorrect details in the
            registration information.
          </Text>
          <Text className="service-box-content">
            3. If registering as a member is determined to cause significant
            technical difficulties for the "Site."
          </Text>
          <Text className="service-box-content">
            ③ The membership contract is considered established when the "Site"
            accepts the membership application and the acceptance reaches the
            member.
          </Text>
          <Text className="service-box-content">
            ④ If there are changes to the information registered during
            membership, the member must notify the "Site" of such changes by
            updating their information within a reasonable period.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 7 (Membership Withdrawal and Loss of Qualifications)
          </Text>
          <Text className="service-box-content">
            ① Members may request to withdraw from the "Site" at any time, and
            the "Site" will immediately process the membership withdrawal.
          </Text>
          <Text className="service-box-content">
            ② If a member falls under any of the following reasons, the "Site"
            may restrict or suspend their membership:
          </Text>
          <Text className="service-box-content">
            1. If the member registered false information during the membership
            application process.
          </Text>
          <Text className="service-box-content">
            2. If the member fails to pay for goods or services purchased on the
            "Site" or any other debts related to the use of the "Site" by the
            due date.
          </Text>
          <Text className="service-box-content">
            3. If the member interferes with others' use of the "Site" or steals
            information, thereby disrupting the order of electronic commerce.
          </Text>
          <Text className="service-box-content">
            4. If the member uses the "Site" to engage in activities prohibited
            by laws or these terms, or acts against public order and good
            morals.
          </Text>
          <Text className="service-box-content">
            ③ If the same conduct is repeated more than twice or the reason for
            restriction or suspension is not corrected within 30 days after the
            membership is restricted or suspended, the "Site" may revoke the
            membership.
          </Text>
          <Text className="service-box-content">
            ④ If the "Site" revokes a member's qualification, the member's
            registration will be deleted. In this case, the "Site" will notify
            the member and provide at least 30 days for the member to explain
            their position before the deletion.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 8 (Notification to Members)
          </Text>
          <Text className="service-box-content">
            ① When the "Site" provides a notice to a member, it can be sent to
            the email address designated by the member in advance through an
            agreement with the "Site."
          </Text>
          <Text className="service-box-content">
            ② For notifications to an unspecified number of members, the "Site"
            may substitute individual notifications by posting the notice on the
            "Site" bulletin board for at least one week. However, for matters
            that significantly affect the member's own transactions, the "Site"
            will provide individual notifications.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 9 (Purchase Application and Consent to Provide Personal
            Information)
          </Text>
          <Text className="service-box-content">
            ① Users of the "Site" may apply for purchases through the following
            or similar methods, and the "Site" must clearly provide the
            following information to users when applying for a purchase.
          </Text>
          <Text className="service-box-content">
            1. Search and selection of goods, etc.
          </Text>
          <Text className="service-box-content">
            2. Entry of the recipient's name, address, phone number, email
            address (or mobile phone number), etc.
          </Text>
          <Text className="service-box-content">
            3. Confirmation of terms and conditions, restrictions on the right
            to withdraw offers, delivery fees, installation fees, and other
            related costs
          </Text>
          <Text className="service-box-content">
            4. Indication of agreement to these terms and confirmation or
            rejection of the items in Paragraph 3 (e.g., by clicking a checkbox)
          </Text>
          <Text className="service-box-content">
            5. Confirmation of the purchase application for goods, etc., and
            consent to the "Site's" confirmation
          </Text>
          <Text className="service-box-content">
            6. Selection of payment method
          </Text>
          <Text className="service-box-content">
            ② If the "Site" needs to provide a buyer's personal information to a
            third party, it must inform the buyer of the following and obtain
            consent: 1) the recipient of the personal information, 2) the
            purpose of use by the recipient, 3) the items of personal
            information to be provided, and 4) the retention and usage period of
            the personal information by the recipient. (This applies to any
            changes in the consented items as well.)
          </Text>
          <Text className="service-box-content">
            ③ If the "Site" outsources the handling of a buyer's personal
            information to a third party, it must inform the buyer of 1) the
            recipient of the outsourcing and 2) the purpose of the outsourced
            task and obtain consent. (This also applies to any changes in the
            consented items.) However, if the outsourcing is necessary for
            service provision or for the buyer's convenience, the "Site" may
            notify through its privacy policy in accordance with the Act on
            Promotion of Information and Communications Network Utilization and
            Information Protection without going through individual notification
            or consent procedures.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 10 (Formation of Contract)
          </Text>
          <Text className="service-box-content">
            ① The "Site" may refuse to accept a purchase application as
            described in Article 9 if it falls under any of the following
            categories. However, when entering into a contract with a minor, the
            "Site" must notify that if the legal guardian's consent is not
            obtained, the minor or their legal guardian may cancel the contract:
          </Text>
          <Text className="service-box-content">
            1. If the application contains false information, omissions, or
            errors.
          </Text>
          <Text className="service-box-content">
            2. If a minor attempts to purchase goods or services prohibited by
            the Juvenile Protection Act, such as tobacco or alcohol.
          </Text>
          <Text className="service-box-content">
            3. If accepting the purchase application is determined to cause
            significant technical difficulties for the "Site."
          </Text>
          <Text className="service-box-content">
            ② The contract is considered to be established when the "Site's"
            acceptance reaches the user in the form of an acknowledgment of
            receipt as described in Article 12(1).
          </Text>
          <Text className="service-box-content">
            ③ The "Site's" acceptance must include confirmation of the user's
            purchase application, availability of the goods, and information on
            correcting or canceling the purchase application.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 11 (Payment Methods)
          </Text>
          <Text className="service-box-content">
            The payment methods for goods or services purchased on the "Site"
            may be made using one of the following methods. The "Site" cannot
            charge any additional fees for the payment method selected by the
            user.
          </Text>
          <Text className="service-box-content">
            1. Various account transfers such as phone banking, internet
            banking, or mail banking
          </Text>
          <Text className="service-box-content">
            2. Payments via prepaid cards, debit cards, credit cards, etc.
          </Text>
          <Text className="service-box-content">3. Online bank transfers</Text>
          <Text className="service-box-content">
            4. Payments using electronic money
          </Text>
          <Text className="service-box-content">5. Cash on delivery</Text>
          <Text className="service-box-content">
            6. Payments using points or mileage provided by the "Site"
          </Text>
          <Text className="service-box-content">
            7. Payments using gift certificates issued by or recognized by the
            "Site"
          </Text>
          <Text className="service-box-content">
            8. Other electronic payment methods
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 12 (Acknowledgment of Receipt, Modification, and
            Cancellation of Purchase Application)
          </Text>
          <Text className="service-box-content">
            ① When the "Site" receives a purchase application from a user, it
            will send an acknowledgment of receipt to the user.
          </Text>
          <Text className="service-box-content">
            ② Upon receiving the acknowledgment, the user may request a
            modification or cancellation of the purchase application if there
            are any discrepancies in their intent. If the request is made before
            shipment, the "Site" must process the request without delay.
            However, if the payment has already been made, the regulations on
            withdrawal of offers as outlined in Article 15 apply.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 13 (Supply of Goods, etc.)
          </Text>
          <Text className="service-box-content">
            ① Unless otherwise agreed upon, the "Site" will take necessary
            measures such as custom production and packaging to deliver goods
            within 7 business days from the date the user submits the offer. If
            the "Site" has already received full or partial payment for the
            goods, it must take action within 3 business days from the date of
            receiving the payment. The "Site" must also take appropriate
            measures to allow users to check the status of the supply process.
          </Text>
          <Text className="service-box-content">
            ② The "Site" must specify the delivery methods, the party
            responsible for delivery costs, and the delivery period for the
            goods purchased by the user. If the "Site" exceeds the agreed
            delivery period, it must compensate the user for any damages unless
            the "Site" proves there was no intention or negligence.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">Article 14 (Refund)</Text>
          <Text className="service-box-content">
            If the "Site" is unable to deliver or provide the goods due to
            reasons such as a stock shortage, it must promptly notify the user
            of the reason. If the payment for the goods was already received,
            the "Site" must refund the payment within 3 business days or take
            necessary measures for the refund.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            Article 15 (Withdrawal of Offer, etc.)
          </Text>
          <Text className="service-box-content">
            ① Users who have entered into a purchase contract with the "Site"
            may withdraw their offer within 7 days of receiving the written
            agreement as specified in Article 13(2) of the Consumer Protection
            Act in Electronic Commerce. If the supply of goods was delayed, the
            withdrawal period begins when the goods are received or when the
            supply of the goods begins. However, if otherwise specified in the
            Consumer Protection Act in Electronic Commerce, the provisions of
            that law shall apply.
          </Text>
          <Text className="service-box-content">
            ② Users may not return or exchange goods in the following cases:
          </Text>
          <Text className="service-box-content">
            1. If the goods are damaged or destroyed due to reasons attributable
            to the user (However, withdrawal of offer is allowed if the
            packaging was damaged to inspect the goods.)
          </Text>
          <Text className="service-box-content">
            2. If the value of the goods has significantly decreased due to use
            or partial consumption by the user.
          </Text>
          <Text className="service-box-content">
            3. If the value of the goods has significantly decreased due to the
            passage of time, making resale difficult.
          </Text>
          <Text className="service-box-content">
            4. If the goods are easily replicable and the original packaging of
            the goods has been damaged.
          </Text>
          <Text className="service-box-content">
            ③ In cases where the restrictions on withdrawal mentioned in
            Paragraph 2(2) to (4) were not clearly indicated or sample goods
            were not provided by the "Site" beforehand, the user's withdrawal of
            offer is not restricted.
          </Text>
        </Box>

        <Box className="service-box">
          <Text className="service-box-title">
            Article 16 (Effect of Withdrawal of Offer, etc.)
          </Text>
          <Text className="service-box-content">
            ① When the "Site" receives returned goods from the user, it will
            refund the payment for the goods within 3 business days.
          </Text>
          <Text className="service-box-content">
            ② In cases where the user paid for the goods using a credit card or
            electronic payment method, the "Site" will immediately request the
            business that provided the payment method to stop or cancel the
            payment claim.
          </Text>
          <Text className="service-box-content">
            ③ The cost of returning the goods for withdrawal of offer will be
            borne by the user. However, if the goods were returned due to
            discrepancies between the actual product and its description or
            incorrect fulfillment of the contract, the "Site" will bear the
            return costs. The "Site" will not claim any penalties or damages for
            withdrawal of the offer.
          </Text>
          <Text className="service-box-content">
            ④ If the user paid for shipping when receiving the goods, the "Site"
            must clearly indicate who is responsible for the shipping cost in
            the event of a withdrawal of the offer.
          </Text>
        </Box>

        <Box className="service-box">
          <Text className="service-box-title">
            Article 17 (Personal Information Protection)
          </Text>
          <Text className="service-box-content">
            ① The "Site" collects the minimum amount of personal information
            necessary to provide its services when collecting users' personal
            information.
          </Text>
          <Text className="service-box-content">
            ② The "Site" does not pre-collect information required for the
            fulfillment of purchase contracts during membership registration.
            However, if identity verification is necessary to fulfill legal
            obligations before a purchase contract, the "Site" may collect the
            minimum amount of specific personal information.
          </Text>
          <Text className="service-box-content">
            ③ When collecting and using users' personal information, the "Site"
            must inform users of the purpose and obtain their consent.
          </Text>
          <Text className="service-box-content">
            ④ The "Site" may not use the collected personal information for
            purposes other than those initially intended. If a new purpose
            arises or the information is to be provided to a third party, the
            "Site" must notify the user of the new purpose and obtain their
            consent at the time of provision. However, exceptions may be made if
            otherwise specified by related laws.
          </Text>
        </Box>
      </Center>
    </Box>
  );
}
